"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _component = _interopRequireDefault(require("../core/component"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _jquery = _interopRequireDefault(require("jquery"));

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var log = (0, _debug.default)('admin.directive');
var showDom = null;

var Directive = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Directive, _Component);

  function Directive(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};

    if (!showDom) {
      showDom = (0, _jquery.default)("<div id=\"" + _tools.default.uuid() + "\"></div>")[0];
      (0, _jquery.default)(document.body).append(showDom);
    }

    return _this;
  }
  /**
   * 在组件从 DOM 中移除的时候立刻被调用。
   */


  var _proto = Directive.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {};

  _proto.render = function render() {
    return /*#__PURE__*/_reactDom.default.createPortal(this.props.children, showDom);
  };

  return Directive;
}(_component.default);

Directive.displayName = 'Directive';
var _default = Directive;
exports.default = _default;
module.exports = exports.default;